import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page } from '../shared';

import { NavLink } from 'react-router-dom';

import {
  fetchMyAssessments
} from '../../actions/assessments';

//TODO create our own
// import AssessmentResultsView from '../takeAssessment/assessmentResultsView';

class StrengthsPage extends Component {

  fetchAssessmentsIfNotFetched(){
    if(this.props.user.uid && !this.props.myAssessments && !this.props.loadingMyAssessments){
      console.log('fetching assessments!');
      this.props.fetchMyAssessments();
    }
  }
  //always fetch on mount to ensure we have latest data
  componentDidMount(){
    this.props.fetchMyAssessments();
    this.fetchAssessmentsIfNotFetched();
  }
  componentDidUpdate(){

    console.log('know updated: ', this.props);

    this.fetchAssessmentsIfNotFetched();
  }

  hasScoredAssessment(){
    const { myAssessments } = this.props;

    const hasScoredAssessment = _.find(myAssessments, {status: 'scored'}) ? true : false;

    return hasScoredAssessment;
  }

  hasInProgressAssessment(){
    const { myAssessments } = this.props;

    const hasInProgressAssessment = _.find(myAssessments, {status: 'inprogress'}) ? true : false;

    return hasInProgressAssessment;
  }

  renderTakeAssessmentPrompt(){
    if(this.hasInProgressAssessment()){
      return (
        <p>Click "Resume Assessment" to resume taking the assessment...</p>
      )
    }
    else{
      return (
        <p>Click "Begin Assessment" to get started</p>
      )
    }
  }

  renderPageTitle(){

    let title = '';
    let subtitle = '';

    console.log('renderingpage title w/ : ', this.props.loadingMyAssessments);

    if(this.props.loadingMyAssessments){
      title = 'Loading assessment...';
      subtitle = '...';
    }
    else if(this.hasScoredAssessment()){
      title = 'Uncover Your Strengths';
      subtitle = '';
    }
    else if(this.hasInProgressAssessment()){
      title = 'Uncover Your Strengths';
      subtitle = 'Complete assessment to view results';
    }
    else{
      //no assessment data
      title = 'Uncover Your Strengths';
      subtitle = 'Begin your assessment to unlock strengths insights';
    }

    return (
      <div className="page-title">
        <h1>{title}</h1>
        <h3>{subtitle}</h3>
      </div>
    )
  }

  renderAssessmentResults(){

    const lastScoredAssessment = _.findLast(_.sortBy(this.props.myAssessments, 'completedOn'), assessment => {
      return assessment.status === 'scored';
    });

    if(!lastScoredAssessment){
      return null;
    }

    //assessment results online view here?
    return (
      <div>
        <p>Interactive report coming soon. In the meantime, click the button below to access your personalized playbook...</p>
        <a href={lastScoredAssessment.playbookDownloadUrl} target="_blank">
          <button className="button primary">Access My Playbook</button>
        </a>
      </div>
    )
  }

  renderPageActions(){

    const {
      pendingAssessment,
      currentAssessmentConfig,
    } = this.props.user;

    if(this.props.loadingMyAssessments){
      return null;
    }
    else if(this.hasScoredAssessment()){
      return null
    }
    else if(this.hasInProgressAssessment()){
      //use currentAssessmentconfig
      return (
        <div className="page-actions">
          <NavLink to={`/a/${currentAssessmentConfig.assessmentName}?profile=${currentAssessmentConfig.profileName}`}>
            <button className="button primary">Resume Assessment</button>
          </NavLink>
        </div>
      )
    }
    else if(pendingAssessment){
      //use pending assessment info, since user might not have currentAssessmentConfig setup
      //needs to be new tab if first time taking assessment in order to setup assessmentConfig on user
      return (
        <div className="page-actions">
          <a href={`/a/${pendingAssessment.assessmentName}?profile=${pendingAssessment.profileName}`} target="_blank">
            <button className="button primary">Begin Assessment</button>
          </a>
        </div>
      )
    }
    else{
      return null;
    }
  }

  render(){

    const { loadingMyAssessments } = this.props;
    const hasScoredAssessment = this.hasScoredAssessment();
    const hasInProgressAssessment = this.hasInProgressAssessment();

    return (
      <Page pageClass="know">
        {this.renderPageTitle()}
        {this.renderPageActions()}

        <div className="page-section">
          {!loadingMyAssessments && !hasScoredAssessment && this.renderTakeAssessmentPrompt()}
          {!loadingMyAssessments && hasScoredAssessment && this.renderAssessmentResults()}
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    myAssessments: state.myAssessments.data,
    loadingMyAssessments: state.myAssessments.loading,
    appConfig: state.appConfig.data,
    orgConfig: state.orgConfig.data,
  }
}

export default connect(mapStateToProps, { fetchMyAssessments })(StrengthsPage);



// WEBPACK FOOTER //
// ./src/components/strengths/index.js